import template from './product-filter-form.template.html';
import controller from './product-filter-form.controller';
import './product-filter-form.scss';

export default {
  template,
  controller,
  bindings: {
    onFilterSubmit: '&?',
    onFilterReady: '&?',
    reloadPageOnChange: '<?',
  },
};



// WEBPACK FOOTER //
// ./src/app/product/product-filter/product-filter-form/product-filter-form.component.js